import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    ValidationErrors,
    Validators,
} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AuthWebService} from 'app/services/authweb.service';
import {CarrierService} from 'app/services/carrier.service';
import {CountryService} from 'app/services/country.service';
import {GooglePlacesSearchService} from 'app/services/google-places-search.service';
import {
    CountryISO,
    SearchCountryField,
    TooltipLabel,
} from 'app/shared/projects/ngx-intl-tel-input/src/public_api';
import {CarrierDepotService} from '../service/carrier-depot.service';
import {ToastNotificationService} from '../../shared/toast-notification/toast-notification.service';
import {
    NgbCalendar,
    NgbDateAdapter,
    NgbDateParserFormatter,
    NgbDateStruct,
    NgbActiveModal,
    NgbModal,
    NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import {DatePipe} from '@angular/common';
import {CarrierTypeService} from 'app/services/carrier-type.service';
import {validateID} from 'app/validators/south_african_id_customizer';
import {DocumenttypeService} from 'app/services/documenttype.service';
import {environment} from 'environments/environment';
import {DocumentsServiceService} from 'app/services/documents-service.service';
import {ConfirmDialogService} from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import {DomSanitizer} from '@angular/platform-browser';
import {OcasService} from 'app/ocas/Service/ocas.service';
import * as moment from 'moment';

@Component({
    selector: 'app-carrier-depot-add',
    templateUrl: './carrier-depot-add.component.html',
    styleUrls: ['./carrier-depot-add.component.scss'],
})
export class CarrierDepotAddComponent implements OnInit {
    @Input() carrierId;
    @Input() depotId;
    @Output() saved = new EventEmitter();
    depotForm: FormGroup;
    currentDate: any = {
        day: new Date().getDate(),
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
    };
    isLoading: boolean = false;
    user: any = {};
    carrierDetails: any = [];
    branches: any = [];
    depotDetails = [];
    ddlCountries = [];
    uploadedDocs: any = [];
    viewDocuments: any = [];
    maxMB: any = environment.authWebApi.systemData.Configurations.find(
        (p) => p.Code == 'MaxUploadMB1'
    ).Value;
    carrier_type_id: any;
    name: any;
    cresult: any;
    UserDocuments: any = [];
    DocTypesList: any = [];
    hasDocuments: boolean = false;
    fileToUpload: File = null;
    fileName = '';
    isRemove = false;
    removeRef: any;
    pdfSrc: any;
    isViewMode: boolean = false;
    img: any;
    isLoadingImg = false;
    idTypes = [
        // { key: 0, value: "Unknown" },
        {key: 1, value: 'ID Number'},
        {key: 2, value: 'Foreign Passport / ID Number'},
        // { key: 3, value: "Company Registration Number" },
        // { key: 4, value: "NPO Number" },
        // { key: 5, value: "(key 5)" },
        // { key: 6, value: "Closed Corporation Reg No" },
        // { key: 7, value: "Trust Registration No" },
        // { key: 8, value: "ID Number of Main Partner" },
    ];

    genderTypes = [
        {key: 'Male', value: 'Male'},
        {key: 'Female', value: 'Female'},
        {key: 'NA', value: 'Prefer Not To Say'},
    ];

    depotTypes = [
        {key: 'Freight', value: 'Freight'},
        {key: 'Passenger', value: 'Passenger'},
        {key: 'Both', value: 'Both'},
    ];
    filebytes: string;
    filename: string;
    filetype: string;
    filesize: string;
    filedescription: string;

    separateDialCode = true;
    SearchCountryField = SearchCountryField;
    TooltipLabel = TooltipLabel;
    CountryISO = CountryISO;
    defaultCountry: any = CountryISO.SouthAfrica;
    defaultCountryPhone: any = CountryISO.SouthAfrica;
    preferredCountries: CountryISO[] = [
        CountryISO.Angola,
        CountryISO.Botswana,
        CountryISO.Comoros,
        CountryISO.CongoDRCJamhuriYaKidemokrasiaYaKongo,
        CountryISO.Lesotho,
        CountryISO.Madagascar,
        CountryISO.Malawi,
        CountryISO.Mauritius,
        CountryISO.Mozambique,
        CountryISO.Namibia,
        CountryISO.Seychelles,
        CountryISO.Swaziland,
        CountryISO.Zambia,
        CountryISO.Zimbabwe,
    ];

    placesPredictions: any = [];
    isPlacesPredictionVible = false;
    placesPostalPredictions: any = [];
    isPostalPlacesPredictionVible = false;
    passport_expiry_date: any;
    date_of_birth: any;

    errorField: any = {
        first_name: 'First Name is required',
        last_name: 'Last Name is required',
        id_number: 'ID Number is required',
        traffic_register_number: 'Traffic Register Number (TRN) is required',
        trn_issue_date: 'TRN\'s date-of-issue is required',
        cellphone: 'Mobile Number is incorrect',
        id_type_ind: 'ID Type is required',
        depot_id: 'Depot Name is required',
        date_of_birth: 'Date of birth is required',
        gender: 'Gender is required',
        license_number: 'License Number is required',
        license_type: 'License Type Date is required',
    };
    foreignErrorField: any = {
        passport_number: 'Passport Number is required',
        work_permit_number: 'Work Permit Number is required',
        work_permit_expiry_date: 'Work Permit Expiry Date is required',
        passport_country_id: 'Country is required',
        passport_expiry_date: 'Passport Expiry Date is required',
    };
    _type: any;
    homeaffairsReadOnly: boolean = false;
    minValidityDate:any;
    maxDOB: any;
    lockHomeAffairs: boolean;
    readonly DT_FORMAT = "DD/MM/YYYY";

    constructor(
        private _fb: FormBuilder,
        private countryService: CountryService,
        private googleSearch: GooglePlacesSearchService,
        private _carrierService: CarrierDepotService,
        private _router: Router,
        private toastService: ToastNotificationService,
        private _carrierInfo: CarrierService,
        private datePipe: DatePipe,
        private _activatedRoute: ActivatedRoute,
        private authWebService: AuthWebService,
        private _carrierType: CarrierTypeService,
        private _documentType: DocumenttypeService,
        private documentService: DocumentsServiceService,
        private confirmDialogService: ConfirmDialogService,
        private calendar: NgbCalendar,
        private sanitizer: DomSanitizer, private _ocas: OcasService,
    ) {
        this.user = this.authWebService.userData
            ? this.authWebService.userData.User
            : null;
    this.maxDOB = {day: new Date().getDate(), month: (new Date().getMonth() + 1), year: new Date().getFullYear() -18}
    this.minValidityDate = {day: new Date().getDate(), month: (new Date().getMonth() + 1), year: new Date().getFullYear()}
    }

    ngOnInit(): void {
        this._ocas.stage = 'depot';
        this.createDepotInfoForm();
        this.listCountries();
        this.rcpsDocsType();
        if (this.carrierId) {
            this.getCarrierInfo();
        }
        if (this.depotId) {
            this.getDepotDetails();
        }
    }

    getCarrierType(id) {
        this._carrierType.getById(id).subscribe((x: any) => {
            this._type = x.description;
        });
    }

    getCarrierInfo() {
        this.isLoading = true;
        this._carrierInfo
            .getCompanyDetailsById(this.carrierId)
            .subscribe((res: any) => {
                console.log(res)
                if (res) {
                    this.carrierDetails = res.Carrier;
                    this.getCarrierType(res.Carrier.carrier_type_id)
                }
                if (res && res.Branches) {
                    this.branches = res.Branches;
                }
                console.log(res.Branches);
                this.isLoading = false;
            });
    }

    getDepotDetails() {
        console.log(this.depotId);

        this.isLoading = true;
        this._carrierService.getDepotDetails(this.depotId).subscribe((res: any) => {
            if (res) {

                this.depotDetails = res;
                setTimeout(() => {
                    let date: any = this.datePipe.transform(res.date_of_birth, 'yyyy/MM/dd');

                    this.depotForm.get('date_of_birth').patchValue(date);
                    this.depotForm.get('date_of_birth').setErrors(null);
                    // this.depotForm.get('date_of_birth').updateValueAndValidity();
                    this.date_of_birth = date;
                    if (res.work_permit_expiry_date != null) {
                        let dateW: any = this.datePipe.transform(res.work_permit_expiry_date, 'yyyy/MM/dd');
                        this.depotForm.get('work_permit_expiry_date').patchValue(dateW);
                        this.depotForm.get('work_permit_expiry_date').setErrors(null);
                    }
                    if (res.passport_expiry_date != null) {
                        let dateP: any = this.datePipe.transform(res.passport_expiry_date, 'yyyy/MM/dd');
                        this.depotForm.get('passport_expiry_date').patchValue(dateP);
                        this.depotForm.get('passport_expiry_date').setErrors(null);
                        this.depotForm.get('passport_expiry_date').updateValueAndValidity();
                        this.passport_expiry_date = dateP;
                        console.log(this.passport_expiry_date)
                    }
                    if (res.trn_issue_date != null) {
                        let dateT: any = this.datePipe.transform(res.trn_issue_date, 'yyyy/MM/dd');
                        this.depotForm.get('trn_issue_date').setValue(dateT);
                        this.depotForm.get('trn_issue_date').setErrors(null);
                    }
                    if(res.id_type_ind === 1){
                        this.setHomeAffairDefaults();
                    }else{
                        this.deactivateHomeAffairs();
                    }
                    console.log(this.depotForm.value)
                }, 0);
                this.depotForm.patchValue(this.depotDetails);
                this.getCarrierExistingDocuments();


                this.isLoading = false;
            }
        });
    }

    createDepotInfoForm() {
        this.depotForm = new FormGroup({
            carrier_id: new FormControl(null),
            branch_carrier_id: new FormControl(null),
            depot_type: new FormControl(null, Validators.required),
            name: new FormControl(null, [
                Validators.required,
                Validators.maxLength(100),
            ]),
            number_of_vehicles: new FormControl(null, Validators.required),
            telephone: new FormControl('', [
                Validators.required,
                Validators.maxLength(100),
            ]),
            physical_address_1: new FormControl(null, Validators.required),
            physical_address_town: new FormControl(null, Validators.required),
            physical_post_code: new FormControl(null, Validators.required),
            physical_place_id: new FormControl(null, Validators.required),
            notes: new FormControl(null),
            id_type_ind: new FormControl(null, Validators.required),
            id_number: new FormControl(null),
            passport_number: new FormControl(null),
            passport_country_id: new FormControl(null),
            passport_expiry_date: new FormControl(null),
            first_name: new FormControl(
                null,
                Validators.compose([Validators.required, Validators.maxLength(50)])
            ),
            last_name: new FormControl(null, [
                Validators.required,
                Validators.maxLength(50),
            ]),
            date_of_birth: new FormControl(null, Validators.required),
            gender: new FormControl(null, Validators.required),
            email: new FormControl('', [
                Validators.required,
                Validators.pattern(
                    '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'
                ),
                Validators.maxLength(100),
            ]),
            cellphone: new FormControl(undefined, [Validators.required]),
            physical_address_2: new FormControl(null),
            physical_address_3: new FormControl(null),
            experience: new FormControl(undefined, [Validators.required]),
            qualification: new FormControl(undefined, [Validators.required]),
        });

        const idNumberControl = this.depotForm.get('id_number');
        const dateOfBirthControl = this.depotForm.get('date_of_birth')
        const genderControl = this.depotForm.get('gender');
        const id_type_indControl = this.depotForm.get('id_type_ind')
        //
        id_type_indControl.valueChanges.subscribe(value => {
            console.log('id_type_indControl', value);
            if (id_type_indControl.value === '1') {
                idNumberControl.setValidators([Validators.required, validateID()]);
            } else {
                idNumberControl.setErrors(null);
                idNumberControl.clearValidators();
            }

            // Update the validation state of the FormControl
            idNumberControl.updateValueAndValidity();
        });


        idNumberControl.valueChanges.subscribe(value => {

            if (value?.length > 12) {
                const year = parseInt(value.substring(0, 2));
                const month = parseInt(value.substring(2, 4));
                const day = parseInt(value.substring(4, 6));
                const gender = parseInt(value.substring(6, 10));

                const isFemale = gender < 5000;

                if (isFemale) {
                    genderControl.patchValue('Female');
                } else {
                    genderControl.patchValue('Male');
                }


                let tempDate = new Date(
                    year,
                   month,
                 day
                );
                console.log("Date of Birth", tempDate)
                let dob = {day: tempDate.getDate(), month: tempDate.getMonth(), year: tempDate.getFullYear()}
                console.log("Date of Birth", dob)
                dateOfBirthControl.setValue(dob);

                // this.getHomeAffairsCarrierDetails();
            }
        });
    }

    rcpsDocsType() {
        this._documentType.getRCPDocsTypes().subscribe((x: any) => {
            this.uploadedDocs = x.filter(x => x.code !== 'WP-RCP')
        })
    }

    idChange() {

        this.depotForm.patchValue({
            id_number: '', first_name: '', last_name: '', date_of_birth: '', gender: '',email:'',cellphone:'',experience:'',qualification:''
        });

        if (this.depotForm.controls.id_type_ind.value == 2) {
            this._documentType.getRCPDocsTypes().subscribe((x: any) => {
                this.uploadedDocs = x;
                this.deactivateHomeAffairs();
            })
        }else{
            this.setHomeAffairDefaults();
        }
    }

    validateID(id: any): boolean {
        let id_number = id;
        let correct = true;
        if (id_number === 13) {
            if (
                id_number.length != 13 ||
                (!isNaN(parseFloat(id_number)) && isFinite(id_number)) // SA ID Number have to be 13 digits, so check the length
                /*!this.isNumber(id_number)*/
            ) {
                this.toastService.error(
                    'ID Number must be numeric and not longer than 13 characters',
                    'Depot'
                );
                this.depotForm.get('id_number').markAsDirty();
                correct = false;
                return;
            }
            // get first 6 digits as a valid date
            let tempDate = new Date(
                id_number.substring(0, 2),
                id_number.substring(2, 4) - 1,
                id_number.substring(4, 6)
            );
            let id_date =
                tempDate.getDate().toString().length < 2
                    ? '0' + tempDate.getDate().toString()
                    : tempDate.getDate().toString();
            let id_month =
                (tempDate.getMonth() + 1).toString().length < 2
                    ? '0' + (tempDate.getMonth() + 1).toString()
                    : (tempDate.getMonth() + 1).toString();
            let id_year = tempDate.getFullYear().toString().slice(-2);
            //let dob = new Date(id_year + '/' + id_month + '/' + id_date);
            let dob = {day: tempDate.getDay(), month: tempDate.getMonth(), year: tempDate.getDate()}
            console.log("Date of dob: " + dob)
            this.depotForm.patchValue({
              date_of_birth: dob,
            });
            if (
                !(
                    id_year == id_number.substring(0, 2).toString() &&
                    id_month == id_number.substring(2, 4).toString() &&
                    id_date == id_number.substring(4, 6).toString()
                )
            ) {
                correct = false;
            }
        } else {
            correct = false;
        }
    }

    ChangeCountry(event) {
        this.defaultCountry = event.iso2;
    }

    ChangeCountryPhone(event) {
        this.defaultCountryPhone = event.iso2;
    }

    listCountries = () => {
        // this.isLoading = true;
        this.countryService.listCountries().subscribe(
            (result: any) => {
                this.ddlCountries = result;
                // this.isLoading = false;
                //console.log(this.ddlCountries);
            },
            (error) => {
                // this.isLoading = false;
                //console.log(error);
            }
        );
    };

    onPhysicalAddressChange(physicalAddressInput) {
        if (physicalAddressInput.value.length > 1) {
            this.googleSearch
                .searchPlace(physicalAddressInput.value)
                .subscribe((data: any) => {
                    this.placesPredictions = data.predictions;
                    if (this.placesPredictions.length > 0) {
                        this.isPlacesPredictionVible = true;
                    }
                });
        } else {
            this.isPlacesPredictionVible = false;
        }
    }

    clickSearchedPlace(place, control) {
        this.populateAddressInputs(place, true, control);
        this.isPlacesPredictionVible = false;
    }

    physicalAddressFocus() {
        if (this.placesPredictions.length > 0) {
            this.isPlacesPredictionVible = true;
        }
    }

    physicalAddressBlur() {
        setTimeout(() => {
            this.isPlacesPredictionVible = false;
        }, 300);
    }

    onPostalAddressChange(postalAddressInput) {
        if (postalAddressInput.value.length > 1) {
            this.googleSearch
                .searchPlace(postalAddressInput.value)
                .subscribe((data: any) => {
                    this.placesPostalPredictions = data.predictions;
                    if (this.placesPostalPredictions.length > 0) {
                        this.isPostalPlacesPredictionVible = true;
                    }
                });
        } else {
            this.isPostalPlacesPredictionVible = false;
        }
    }

    clickSearchedPlacePostal(place, control) {
        this.populateAddressInputs(place, false, control);
        this.isPostalPlacesPredictionVible = false;
    }

    postalAddressFocus() {
        if (this.placesPostalPredictions.length > 0) {
            this.isPostalPlacesPredictionVible = true;
        }
    }

    postalAddressBlur() {
        setTimeout(() => {
            this.isPostalPlacesPredictionVible = false;
        }, 300);
    }

    populateAddressInputs(place, isPhysical, control) {
        this.googleSearch
            .searchPlaceDetails(place.place_id)
            .subscribe((data: any) => {
                let lattitude = data.result.geometry.location.lat;
                let longitude = data.result.geometry.location.long;
                let addressLine_comps = '';
                let addressLine_1 = data.result.address_components.find(
                    (c) => c.types.indexOf('street_number') > -1
                );
                if (addressLine_1 != undefined) {
                    addressLine_comps = addressLine_1.long_name;
                }
                let addressLine_2 = data.result.address_components.find(
                    (c) => c.types.indexOf('route') > -1
                );
                if (addressLine_comps == '' && addressLine_2 != undefined) {
                    if (addressLine_comps != addressLine_2.long_name) {
                        addressLine_comps = addressLine_2.long_name;
                    }
                }
                if (addressLine_comps != '' && addressLine_2 != undefined) {
                    if (addressLine_comps != addressLine_2.long_name) {
                        addressLine_comps =
                            addressLine_comps + ' ' + addressLine_2.long_name;
                    }
                }
                let townStr = '';
                let locality = data.result.address_components.find(
                    (c) =>
                        c.types.indexOf('sublocality_level_1') > -1 ||
                        c.types.indexOf('sublocality') > -1 ||
                        c.types.indexOf('locality') > -1
                );
                if (locality != undefined) {
                    townStr = locality.long_name;
                }

                let postalStr = '';
                let postalCode = data.result.address_components.find(
                    (c) => c.types.indexOf('postal_code') > -1
                );
                if (postalCode != undefined) {
                    postalStr = postalCode.long_name;
                }

                let countryIdInt = '';
                let country = data.result.address_components.find(
                    (c) => c.types.indexOf('country') > -1
                );
                if (country != undefined) {
                    let dbCountry = this.ddlCountries.find(
                        (c) =>
                            c.desc.toLowerCase() == country.long_name.toLowerCase() ||
                            c.code.toLowerCase() == country.short_name.toLowerCase()
                    );
                    if (dbCountry != undefined) {
                        countryIdInt = dbCountry.id;
                    }
                }
                if (control === 'physical_address_1') {
                    if (isPhysical) {
                        this.depotForm.patchValue({
                            physical_address_1: addressLine_comps,
                            physical_address_town: townStr,
                            physical_post_code: postalStr,
                            physical_place_id: countryIdInt,
                        });
                    }
                    if (!isPhysical) {
                        this.depotForm.patchValue({
                            physical_address_1: addressLine_comps,
                            physical_address_town: townStr,
                            physical_post_code: postalStr,
                            physical_place_id: countryIdInt,
                        });
                    }
                } else if (control === 'physical_address_2') {
                    if (isPhysical) {
                        this.depotForm.patchValue({
                            physical_address_2: addressLine_comps,
                            lat: lattitude,
                            long: longitude,
                            // physical_address_town: townStr,
                            // physical_post_code: postalStr,
                            // physical_place_id: countryIdInt,
                        });
                    }
                    if (!isPhysical) {
                        this.depotForm.patchValue({
                            physical_address_2: addressLine_comps,
                        });
                    }
                }
            });
    }

    updateValidations() {
        if (this.depotForm.value.id_type_ind == 1) {
            this.depotForm.get('id_number').setValidators([Validators.required]);
            this.depotForm.get('id_number').updateValueAndValidity();

            this.depotForm.get('passport_expiry_date').clearValidators();
            this.depotForm.get('passport_number').clearValidators();
            this.depotForm.get('passport_country_id').clearValidators();

            this.depotForm.get('passport_expiry_date').updateValueAndValidity();
            this.depotForm.get('passport_number').updateValueAndValidity();
            this.depotForm.get('passport_country_id').updateValueAndValidity();
        }
        if (this.depotForm.value.id_type_ind == 2) {
            this.depotForm
                .get('passport_expiry_date')
                .setValidators([Validators.required]);
            this.depotForm
                .get('passport_number')
                .setValidators([Validators.required]);
            this.depotForm
                .get('passport_country_id')
                .setValidators([Validators.required]);

            this.depotForm.get('id_number').clearValidators();
            this.depotForm.get('id_number').updateValueAndValidity();

            this.depotForm.get('passport_expiry_date').updateValueAndValidity();
            this.depotForm.get('passport_number').updateValueAndValidity();
            this.depotForm.get('passport_country_id').updateValueAndValidity();
        }
    }
    getFormValidationErrors() {
        Object.keys(this.depotForm.controls).forEach(key => {
            const controlErrors: ValidationErrors = this.depotForm.get(key).errors;
                if (controlErrors != null) {
                        Object.keys(controlErrors).forEach(keyError => {
                            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                        });
                    }
            
        });
    }
    submitForm() {
        this.updateValidations();
        this.depotForm.markAsDirty();
        this.depotForm.markAllAsTouched();
        this.isLoading = true;

        this.getFormValidationErrors();
        if (!this.depotForm?.valid) {
            this.isLoading = false;
            this.scrollToFirstInvalidControl();
            this.toastService.error(
                `Please ensure that you fill in all the required details.`,
                'Depot'
            );
            return;
        }
        if (this.depotForm.value) {
            let obj = {...this.depotForm.value};
            obj.carrier_id = this.carrierId;
            this.validateID(obj.id_number);
            if (obj.telephone) {
                obj.iso2_tele = obj.telephone.countryCode;
                obj.dial_code_tele = obj.telephone.dialCode;
                obj.telephone = obj.telephone.number;
            }
            if (obj.cellphone) {
                obj.iso2_cell = obj.cellphone.countryCode;
                obj.dial_code_cell = obj.cellphone.dialCode;
                obj.cellphone = obj.cellphone.number;
            }
            if (obj.passport_expiry_date) {
                obj.passport_expiry_date = this.onDateSelect(obj.passport_expiry_date);
            }

            if (obj.date_of_birth) {
                obj.date_of_birth = this.onDateSelect(obj.date_of_birth);
            }

            if (this.depotId) {
                obj.id = +this.depotId;
                obj.user_modified = this.user?.FirstName;
                obj.date_modified = new Date();

                this._carrierService.updateDepot(obj).subscribe((response: any) => {
                    document.getElementById('reloadDepotList').click();
                    this.toastService.success(
                        `Depot ${obj.name} successfully updated`,
                        'Depot'
                    );
                    if (response) {
                        this.saved.emit(response);
                        this.isLoading = false;
                    }
                });
            } else {
                obj.date_created = new Date();
                obj.user_created = this.user?.FirstName;
                this._carrierService.addDepot(obj).subscribe((response: any) => {
                    this.toastService.success(
                        `Depot ${obj.name} successfully added`,
                        'Depot'
                    );
                    if (response) {
                        this.saved.emit(response);
                        this.isLoading = false;
                    }
                });
            }
        }
    }

    onDateSelect(date) {
        let selectedDate;
    
        if (this.isValidDate(date)) {
            selectedDate = new Date(date);
        } else {
            selectedDate = new Date(date.year, date.month - 1, date.day); // month is zero-based
        }
    
        const formattedDate = this.datePipe.transform(selectedDate, 'yyyy/MM/dd');
        this.depotForm.value.date_of_birth = formattedDate;
        return formattedDate;
    }
    
    isValidDate(date: any): boolean {
        const parsedDate = new Date(date);
        return parsedDate.toString() !== 'Invalid Date' && !isNaN(parsedDate.getTime());
    }

    back() {
        this.saved.emit('false');
    }

    private scrollToFirstInvalidControl() {
        let form = document.getElementById('DepotForm'); 
        let firstInvalidControl = form.getElementsByClassName('ng-invalid')[0];
        firstInvalidControl.scrollIntoView();
        (firstInvalidControl as HTMLElement).focus();
    }

    numbersOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    validatePhone(value: any): boolean {
        if ((value && value.countryCode == 'ZA' && value.number.length <= 9)) {

            return true;
        }
        return false;

    }

    handleFileInput(files: FileList) {
        this.fileToUpload = files.item(0);
        this.fileName = files.item(0).name;
    }

    onFileSelected(event: any, documenttypeid: any) {
        this.setFileData(event, 'upload', documenttypeid);
    }

    setFileData(event: any, description: any, documenttypeid: any) {
        if (documenttypeid != null) {
            const reader = new FileReader();

            if (event.target.files && event.target.files.length > 0) {
                let file: any = null;
                const count = event.target.files.length;

                file = event.target.files[count - 1];
                let result = this.checkFileType(file.name);
                let fileFound = false;

                console.log('FileName', file.name);


                this.viewDocuments.forEach(
                    function (value) {
                        if (file.name == value.file_name) {
                            fileFound = true;
                            this.toastService.error(
                                `You already uploaded this file`,
                                'File upload failed'
                            );
                            return false;
                        }
                    }.bind(this)
                );

                if (fileFound) {
                    return;
                }

                //if File type is in not found
                if (result != -1) {
                    let sizeresult = this.checkFileSize(file.size);

                    if (sizeresult != -1) {

                        reader.removeEventListener;
                        reader.readAsDataURL(file);
                        reader.onload = () => {
                            this.filebytes = reader.result.toString().split(',')[1];
                            (this.filename = file.name), (this.filetype = file.type);
                            this.filedescription = description;
                            this.filesize = file.size;
                            this.validateData(documenttypeid);
                        };
                    } else {
                        let allowedFileSize =
                            environment.authWebApi.systemData.Configurations.find(
                                (p) => p.Code == 'MaxUploadMB1'
                            );
                        // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
                        this.toastService.error(
                            `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,
                            'File Upload Failed, Please try again.'
                        );
                    }
                } else {
                    //send message allowed types
                    let allowedFileTypes =
                        environment.authWebApi.systemData.Configurations.find(
                            (p) => p.Code == 'UploadDocTypes1'
                        );

                    // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Only these file types are allowed: PDF  ${allowedFileTypes.Value.toString()}`, statuscode: '404',url: null, servermessage: "Extension not allowed"});
                    this.toastService.error(
                        `Only these file types are allowed: PDF`,
                        'File Upload Failed, Please try again.'
                    );
                }
            }

            // this.showOtherUploadsOption = false;
        }
    }

    checkFileType(fileName: string) {
        // from the file name derive the extension
        let allowedFileTypes =
            environment.authWebApi.systemData.Configurations.find(
                (p) => p.Code == 'UploadDocTypes1'
            );
        let fileTypesArray = allowedFileTypes.Value.toString().split(',');
        //check if file type is
        let ext = fileName.split('.')[1].toUpperCase();
        let count = fileTypesArray.length;
        for (let iter = 0; iter < count; iter++) {
            if (fileTypesArray[iter] == ext) {
                return iter;
            }
        }
        return -1;
    }

    checkFileSize(fileSize: number) {
        // get the maximum file size
        let allowedFileSize = environment.authWebApi.systemData.Configurations.find(
            (p) => p.Code == 'MaxUploadMB1'
        );
        let maxAllowedSize = allowedFileSize.Value; //it is in MB
        let document_sizeMB = fileSize / 1000000;
        if (document_sizeMB <= maxAllowedSize) {
            return 1;
        } else {
            return -1;
        }
        //
    }

    validateData(documenttypeid: any) {

        if (this.depotForm.controls.id_type_ind.value == null) {
            return this.toastService.error('Please select id type first!', 'Warning');
        }
        if (this.depotForm.controls.id_type_ind.value == 1 && this.depotForm.value.id_number == null) {
            return this.toastService.error('Please fill in id number first!', 'Warning');
        }
        if (this.depotForm.controls.id_type_ind.value == 2 && this.depotForm.value.passport_number == null) {
            return this.toastService.error('Please fill in your passport number first!', 'Warning');
        }
        if (this.carrierId == null) {
            // this.dialogService.addDialog(AlertComponent, { title: 'Error', message: 'Unable to upload documents ' })
            this.toastService.error('Unable to upload documents ', 'Error');
        } else {
            this.postFile(this.carrierId, documenttypeid);
        }
    }

    postFile(CarrierID: any, documenttypeid: any) {
        //this.uploader.nativeElement.value = ''

        const formdata = new FormData();
        formdata.append('File', this.filebytes);
        formdata.append('FileName', this.filename);
        formdata.append('TypeOfFile', this.filetype);
        formdata.append('FileSize', this.filesize);
        formdata.append('documenttypeid', documenttypeid);
        formdata.append('CarrierID', CarrierID);
        formdata.append('UserLastName', this.user.LastName);
        formdata.append('CarrierName', this.name);
        if (this.depotForm.controls.id_type_ind.value == 1) {
            formdata.append('Notes', this.depotForm.value.id_number);
        }
        if (this.depotForm.controls.id_type_ind.value == 2) {
            formdata.append('Notes', this.depotForm.value.passport_number);
        }


        this.isLoading = true;


        this.documentService
            .postDocument(formdata, documenttypeid, CarrierID)
            .subscribe(
                (response) => {
                    //this.dialogService.addDialog(AlertComponent, {
                    //    title: 'File Uploaded',
                    //    message: 'File: ' + this.filename + ' was successfully uploaded.',
                    //    bold: this.filename
                    //})
                    this.getCarrierExistingDocuments()

                },
                (error) => {
                    this.isLoading = false;

                    // this.dialogService.addDialog(ErrorComponent, {
                    //     title: 'File Upload Failed, Please try again.',
                    //     message: error._body , statuscode: error.Status, url: error.Uri, servermessage: error.Message
                    // }),
                    this.toastService.error(
                        'File Upload Failed, Please try again.',
                        ' Error'
                    );
                }
            );
    }

    onFileChange(event, documenttypeid) {
        let file: any = null;
        file = Object.keys(event).map((key) => event[key]);
        this.setDropFileData(file, 'upload', documenttypeid);

        // this.toastr.info(`File uploaded successfully`, 'File Upload.');
    }

    setDropFileData(event: any, description: any, documenttypeid: any) {
        if (documenttypeid != null) {
            const reader = new FileReader();

            if (event && event.length > 0) {
                let file: any = null;
                const count = event.length;

                file = event[count - 1];
                let result = this.checkFileType(file.name);
                let fileFound = false;

                this.UserDocuments.forEach(
                    function (value) {
                        if (file.name == value.file_name) {
                            fileFound = true;
                            this.toastService.error(
                                `You already uploaded this file`,
                                'File upload failed'
                            );
                            return false;
                        }
                    }.bind(this)
                );

                if (fileFound) {
                    return;
                }

                //if File type is in not found
                if (result != -1) {
                    let sizeresult = this.checkFileSize(file.size);

                    if (sizeresult != -1) {

                        reader.removeEventListener;
                        reader.readAsDataURL(file);
                        reader.onload = () => {
                            this.filebytes = reader.result.toString().split(',')[1];
                            (this.filename = file.name), (this.filetype = file.type);
                            this.filedescription = description;
                            this.filesize = file.size;
                            this.validateData(documenttypeid);
                        };
                    } else {
                        let allowedFileSize =
                            environment.authWebApi.systemData.Configurations.find(
                                (p) => p.Code == 'MaxUploadMB1'
                            );
                        // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
                        this.toastService.error(
                            `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,
                            'File Upload Failed, Please try again.'
                        );
                    }
                } else {
                    //send message allowed types
                    let allowedFileTypes =
                        environment.authWebApi.systemData.Configurations.find(
                            (p) => p.Code == 'UploadDocTypes1'
                        );

                    // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Only these file types are allowed: PDF  ${allowedFileTypes.Value.toString()}`, statuscode: '404',url: null, servermessage: "Extension not allowed"});
                    this.toastService.error(
                        `Only these file types are allowed: PDF`,
                        'File Upload Failed, Please try again.'
                    );
                }
            }

            // this.showOtherUploadsOption = false;
        }
    }

    getCarrierExistingDocuments() {
        this.isLoading = true;
        this.documentService.getByCarrierId(this.carrierId).subscribe(
            (result: any) => {
                if (this.depotForm.controls.id_type_ind.value == 1) {
                    this.viewDocuments = result.filter(x => x.notes === this.depotForm.value.id_number);
                }
                if (this.depotForm.controls.id_type_ind.value == 2) {
                    this.viewDocuments = result.filter(x => x.notes === this.depotForm.value.passport_number);
                }
                console.log(this.viewDocuments)
                if (this.viewDocuments.length > 0) {
                    // this.removeUploadedDocTypes();
                }
            },
            (error) => {
                this.viewDocuments = [];

                this.isLoading = false;
                // this.dialogService.addDialog(ErrorComponent, { title: 'Document Uploads', message: `Unable to retrieve carrier documents.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
            }
        );
    }
    getMaxDate(): NgbDateStruct {
        const today = this.calendar.getToday();
       // return today;
       return this.maxDOB;
    }
    onConfirm(doc: any) {
        // this.confirm.showYesNo('Delete Uploaded Document', `Are you sure you want to remove the file ${doc.file_name}  uploaded?`, null, 'Yes', 'No')
        //   .subscribe((isConfirmed) => {
        //     if (isConfirmed) {
        //       this.onDelete(doc)
        //     } else {
        //       return;
        //     }
        //   });
        this.confirmDialogService.confirmThis(
            `Are you sure you want to remove the file ${doc.file_name}  uploaded?`,
            () => {
                this.onDelete(doc);
            },
            () => {
                return;
            }
        );
    }

    onDelete(doc: any) {
        this.isLoading = true;
        this.documentService.delete(doc.id).subscribe(
            (result) => {
                // this.dialogService.addDialog(AlertComponent, { title: 'Delete Document', message: `Document ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
                this.toastService.success(
                    `Document ${doc.code} deleted.`,
                    'Delete Document'
                );
                this.getCarrierExistingDocuments();
                //if (result != null) {
                // this.onNo();
                this.isLoading = false;
                //}
                //this.onChangeHeading();
            },
            (error) => {
                error = error.json();
                this.isLoading = false;
                // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Document', message: `Document ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
                this.toastService.error(
                    `Document ${this.removeRef.code} was not deleted.`,
                    'Delete Document'
                );
            }
        );
    }

    viewDoc(id, fileName) {
        //alert(id);
        //console.log(id)
        this.isViewMode = true;
        id = fileName.substring(fileName.indexOf('#') + 1);
        this.isLoadingImg = true;
        this.pdfSrc = null;
        this.img = null;
        let ext = fileName.substring(fileName.length - 3, fileName.length);
        //console.log(ext);
        if (fileName.includes('.pdf')) {
            this.documentService.downloadpdf(id).subscribe((x) => {
                console.log(x);

                let objectURL = URL.createObjectURL(x);
                this.pdfSrc = objectURL;

                //alert(this.pdfSrc.toString());
                //this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
                //console.log(this.pdfSrc)
                this.isLoadingImg = false;
                this.isLoading = false;
            });
            return;
        }

        this.documentService.download(id).subscribe((x) => {
            let objectURL = URL.createObjectURL(x);
            console.log(objectURL);
            this.pdfSrc = null;
            this.img = this.sanitizer.bypassSecurityTrustUrl(objectURL);
            console.log(this.img);
            this.isLoadingImg = false;
            // this.img = x;
        });
    }

    letterOnly(event) {
        var charCode = event.keyCode;

        if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8) {
            return true;
        } else {
            return false;
        }
    }

    getHomeAffairsCarrierDetails() {

        // let id_type = this.depotForm.get('id_type_ind').value;
        // if (id_type !== 2) {
        //     return false;
        // }

        let id = this.depotForm.get('id_number').value;
        if (id) {
            this._carrierInfo.getHomeAffairsCarrierDetails(id)
                .subscribe(
                    (response: any) => {
                        console.log('Home Affairs Carrier Details:', response);
                        if (response.Error === '0000') {
                            this.depotForm.patchValue({
                                id_number: response.Person.IdNumber, first_name: response.Person.Names, last_name: response.Person.Surname,
                            });
                            this.homeaffairsReadOnly = true;
                        } else if (response.Error === '0400') {
                            this.resetHomeAffairs()
                        } else {
                            this.resetHomeAffairs()
                        }
                    },
                    (error) => {
                        this.toastService.error(`An error occurred when retrieving your details from Home Affairs`, 'Carrier Registration')
                    }
                );
        } else {
            this.toastService.error(`Please enter a valid SA ID`, 'Carrier Registration')
        }

    }

    resetHomeAffairs() {
        this.depotForm.controls['id_number'].setErrors({'invalid_id': true});
        this.depotForm.patchValue({
            id_number: '', first_name: '', last_name: '',
        });
        this.homeaffairsReadOnly = false;
        this.lockHomeAffairs = false;
        this.toastService.error(`Your ID was not found at Home Affairs, please ensure its correct`, 'Carrier Registration')
    }


    deactivateHomeAffairs() {
        this.homeaffairsReadOnly = false;
        this.lockHomeAffairs = false;
    }

    setHomeAffairDefaults() {
        this.homeaffairsReadOnly = true;
        this.lockHomeAffairs = true;
    }

     convertDateFormat(inputDate: string): string {
        // Split the input date into day, month, and year components
        const [year, month, day] = inputDate.split('/').map(Number);
    
        // Create a new Date object using the parsed components
        const parsedDate = new Date(year, month - 1, day);
    
        // Format the parsed date as "yyyy/mm/dd"
        const formattedDate = `${parsedDate.getFullYear()}/${(parsedDate.getMonth() + 1).toString().padStart(2, '0')}/${parsedDate.getDate().toString().padStart(2, '0')}`;
        
        return formattedDate;
    }

    convertToNgbDate(date: Date): NgbDateStruct {
        return {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        };
    }


parse(value: string): NgbDateStruct {
  if (value) {
    value = value.trim();
    let mdt = moment(value, this.DT_FORMAT);
    if (mdt.isValid()) {
      return {
        year: mdt.year(),
        month: mdt.month() + 1, // Months in NgbDateStruct are 1-based
        day: mdt.date()
      };
    }
  }
  return null;
}
    format(date: NgbDateStruct): string {
    if (!date) return "";
    let mdt = moment([date.year, date.month - 1, date.day]);
    if (!mdt.isValid()) return "";
    return mdt.format(this.DT_FORMAT);
    }

    changeBasicContactInfoParm() {
        // this.utility.checkFreight = this.form.controls.freight_passenger_ind.value;
        // if (this.status_id != 1) {
        //     return this.isBasicContactInfo = false;
        // }
    }
    
}
